import ApiProvider from "../../../lib/providers/ApiProvider";
import { serviceUtil } from "../../commons/utils/services";
import { HeadersMapping } from "../../commons/mappings/headers.mapping";
import { URLConfiguration } from "../../commons/constants/url.configuration";
import ConsultarRequest from "./../../commons/mappings/consultarRequest.mapping";

class ConsultarProvider {
    
    constructor() {
        this.paths              = URLConfiguration.paths;
        this.consultarRequest   = new ConsultarRequest();
        this.apiProvider        = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH)
    }

    postConsultarCreateSimulacion = async (datosConsulta) => {
        const headers   = HeadersMapping.getHeaderService();
        const request   = this.consultarRequest.postConsultarCreateSimulacion(datosConsulta);
        const pathNew   = serviceUtil.replaceParamUrl(this.paths.simulacionProductosRentas.createSimulacion, {});
        let response    = null;
        try {
            response = await this.apiProvider.post( pathNew, request, { headers } );
        } catch (error) {
            console.log(error);
        }
        return response;
    }

}

export default ConsultarProvider;